<template>
  <div>
    <template v-if="model.backup_applied">-</template>
    <template v-else>
      {{
        $t("SCORECARDS.PTS", {
          points: `${model?.calculated_points || 0}  ⁄ ${model.points}`,
        })
      }}
    </template>
  </div>
</template>

<script setup lang="ts">
import type { ScorecardGroupCategoryForPreview } from "@/models/scorecards";
import type { PropType } from "vue";

defineProps({
  model: {
    type: Object as PropType<ScorecardGroupCategoryForPreview>,
    required: true,
  },
  modelValue: {
    type: Number,
    required: true,
  },
  value: {
    type: Number,
    required: true,
  },
});
</script>
